import * as go from 'gojs';
import { DRAG_CREATING_TOOL_NAME } from './config';
import { DragCreatingTool } from './drag-creating-tool';

const setupDragCreatingTool = (diagram: go.Diagram) =>
  diagram.toolManager.mouseDownTools.insertAt(2, new DragCreatingTool());

const runDragCreatingTool = (
  diagram: go.Diagram,
  shapeProperties: go.ObjectData,
  cursor: string,
  allowedClickClass: string,
  action: (bounds: go.Rect) => void,
) => {
  const tool = diagram.toolManager.findTool(DRAG_CREATING_TOOL_NAME) as DragCreatingTool;
  tool.cursor = cursor;
  tool.shapeProperties = shapeProperties;
  tool.allowedClickClass = allowedClickClass;
  if (tool) {
    tool.startManually(action);
  }
};

export const dragCreatingToolAPI = {
  setup: setupDragCreatingTool,
  run: runDragCreatingTool,
};
